// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";
// Validation schema
const AdminEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
 
});

export function AdminEditForm({
  admin,
  btnRef,
  saveAdmin,
}) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={admin}
        validationSchema={AdminEditSchema}
        onSubmit={(values) => {
          saveAdmin(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="name"
                    component={Input}
                    placeholder="name"
                    label="Name"
                  />
                </div>
				        <div className="col-lg-4">
                  <Field
                    name="phone_number"
                    component={Input}
                    placeholder="phone number"
                    label="Phone number"
                  />
                </div>
              
              </div>
              
              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
